var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.053,
    height: 74.053,
    viewBox: "0 0 74.053 74.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Helpcenter",
    transform: "translate(0.125 0.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(35.426 51.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M247.236,358.4a1.476,1.476,0,1,0,1.476,1.476A1.477,1.477,0,0,0,247.236,358.4Z",
    transform: "translate(-245.76 -358.4)",
    fill: "#000000",
    stroke: "#000",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(33.951 50.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2.952,
    cy: 2.952,
    rx: 2.952,
    ry: 2.952,
    fill: "#000000",
    stroke: "#000",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M36.9,0A36.9,36.9,0,1,0,73.8,36.9,36.941,36.941,0,0,0,36.9,0Zm0,70.851A33.949,33.949,0,1,1,70.851,36.9,33.988,33.988,0,0,1,36.9,70.851Z",
    transform: "translate(0)",
    fill: "#000000",
    stroke: "#000",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(26.569 17.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M204.817,131.357a10.333,10.333,0,0,0-20.5,1.863,1.476,1.476,0,0,0,2.952,0,7.383,7.383,0,1,1,10.938,6.468,9.309,9.309,0,0,0-5.033,8.292v2.952a1.473,1.473,0,1,0,2.946,0V147.72a6.317,6.317,0,0,1,3.507-5.45A10.382,10.382,0,0,0,204.817,131.357Z",
    transform: "translate(-184.321 -122.889)",
    fill: "#000000",
    stroke: "#000",
    strokeWidth: 0.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/HelpCenter.3b65a324ffe166977e37a5bf1298411d.svg";
export { ForwardRef as ReactComponent };